import type { OAuthApp } from '@wf-coe/types';
import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { useApiClient } from '../lib/use-api-client.js';

/** Wire-format OAuth app — Date fields are ISO strings. */
export type OAuthAppDto = Omit<OAuthApp, 'createdAt' | 'updatedAt'> & {
  createdAt: string;
  updatedAt: string;
};

/**
 * Lists OAuth apps for a given tenant. Disabled until both an api
 * client (signed-in MSAL account) and a `clientId` are available.
 */
export function useOAuthAppsQuery(clientId: string | undefined): UseQueryResult<OAuthAppDto[]> {
  const api = useApiClient();
  return useQuery({
    queryKey: ['oauth-apps', clientId],
    queryFn: () => {
      if (!api) throw new Error('useOAuthAppsQuery: api client unavailable');
      if (!clientId) throw new Error('useOAuthAppsQuery: clientId required');
      return api.get<OAuthAppDto[]>(`/v1/clients/${clientId}/oauth-apps`);
    },
    enabled: api !== undefined && clientId !== undefined,
  });
}
